import { createStandardAction } from 'typesafe-actions';
import { FeedEventData } from '@tradingblock/types';

export const FEED_CLOSED = `@orderStatus/feed/closed`;
export const FEED_ERRORED = `@orderStatus/feed/errored`;
export const FEED_CONNECTED = `@orderStatus/feed/connected`;
export const feedClosed = createStandardAction(FEED_CLOSED)<FeedEventData>();
export const feedErrored = createStandardAction(FEED_ERRORED)<FeedEventData>();
export const feedConnected = createStandardAction(FEED_CONNECTED)();

export const OrderStatusFeedActions = {
  orderStatusFeedClosed: createStandardAction(FEED_CLOSED)<FeedEventData>(),
  orderStatusFeedErrored: createStandardAction(FEED_ERRORED)<FeedEventData>(),
  orderStatusFeedConnected: createStandardAction(FEED_CONNECTED)(),
};
